import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './style.scss';
import { useEffect, useState } from 'react';
import ClockIcon from '../../assets/icons/clock.svg';
const CountdownTimer = ({ duration, running, onTick, onTimeExpired, onRemain, remainThreshold = 600, }) => {
    const [secondsLeft, setSecondsLeft] = useState(duration);
    useEffect(() => {
        let interval;
        if (running) {
            interval = window.setInterval(() => {
                setSecondsLeft((prev) => Math.max(prev - 1, 0));
            }, 1000);
        }
        return () => {
            if (interval !== undefined) {
                clearInterval(interval);
            }
        };
    }, [running]);
    useEffect(() => {
        onTick(secondsLeft);
        if (secondsLeft === remainThreshold && onRemain) {
            onRemain(secondsLeft);
        }
        if (secondsLeft === 0 && running) {
            onTimeExpired();
        }
    }, [secondsLeft]);
    const formatTime = (totalSeconds) => {
        const hours = Math.floor(totalSeconds / 3600)
            .toString()
            .padStart(2, '0');
        const minutes = Math.floor((totalSeconds % 3600) / 60)
            .toString()
            .padStart(2, '0');
        const seconds = (totalSeconds % 60).toString().padStart(2, '0');
        return `${hours}:${minutes}:${seconds}`;
    };
    return (_jsxs("div", { className: "countdown", children: [_jsx("div", { className: "countdown-icon", style: { color: '#f39200' }, children: _jsx(ClockIcon, {}) }), _jsx("div", { className: "countdown-timer", children: formatTime(secondsLeft) })] }));
};
export default CountdownTimer;
